<template>
  <a class="summary__item" :href="eventItem.link" @click.prevent="$emit('clicked')">
    <div v-if="eventItem.date" class="summary__date-wrapper">
      <div class="summary__date-month" v-html="eventItem.displayMonth" />
      <div class="summary__date-day" v-html="eventItem.displayDay" />
    </div>
    <div class="summary__copy-wrapper">
      <h4 class="text-h4 text-color-navy resources__copy-title" v-html="eventItem.title" />
      <RichRenderer :richTextData="eventItem.description" />
      <div v-if="eventItem.date" class="summary__period">
        <span class="text-link" v-html="eventItem.displayFullDate" />
        <span
          v-if="eventItem.additionalDate"
          class="text-link"
          v-html="' — ' + eventItem.displayAdditionalDateFullDate"
        />
      </div>
      <div v-if="eventItem.subtitle" class="summary__loc">
        <p class="text-link" v-html="eventItem.subtitle" />
      </div>
    </div>
    <div v-if="eventItem.img" class="summary__img-wrapper">
      <img :src="eventItem.img" :alt="eventItem.imgAlt" class="summary__img" />
    </div>
  </a>
</template>
<script>
export default {
  props: {
    eventItem: {
      type: Object,
      required: true,
    },
  },
  emits: ['clicked'],
}
</script>
